import { useMemo } from 'react'
import { ORDMarkingFormData } from '@synapex/prisma/client'

export function useContractComputed(markingFormData: ORDMarkingFormData) {
    return useMemo(() => {
        const hasPublisherAndPublishOptionsflags =
            markingFormData.publish_option_flag &&
            markingFormData.publisher_flag

        const shouldDisableAllFields =
            markingFormData.contract_flag && !markingFormData.contract_edo_flag
        const shouldDisableDraftField =
            markingFormData.contract_edo_flag ||
            !hasPublisherAndPublishOptionsflags
        const isBlockedByCreative = markingFormData.creative_flag

        const hasDraftContract =
            !!markingFormData.draft_contract_id ||
            !!markingFormData.custom_contract_id
        const hasFinalContract = !!markingFormData.final_contract_id
        const hasEdoFlag = markingFormData.contract_edo_flag

        const hasPublisherFlag = markingFormData.publisher_flag

        const canEnableContractCheckbox =
            hasDraftContract && (hasFinalContract || hasEdoFlag)

        const isContractCheckboxDisabled =
            !canEnableContractCheckbox ||
            (isBlockedByCreative && markingFormData.contract_flag)

        const canEnableEdoCheckbox = hasDraftContract && !isBlockedByCreative
        const canUploadFinalContract = !shouldDisableAllFields

        const contractFlagError =
            markingFormData.creative_flag && !markingFormData.contract_flag

        const canEditVat =
            !markingFormData.draft_contract_id &&
            !markingFormData.custom_contract_id

        return {
            hasPublisherAndPublishOptionsflags,
            shouldDisableAllFields,
            shouldDisableDraftField,
            isBlockedByCreative,
            hasDraftContract,
            hasFinalContract,
            hasEdoFlag,
            canEnableContractCheckbox,
            isContractCheckboxDisabled,
            canEnableEdoCheckbox,
            canUploadFinalContract,
            contractFlagError,
            canEditVat,
            hasPublisherFlag,
        }
    }, [markingFormData])
}
